import request from '@utils/request';

/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function login(data) {
    return request.post('login', data, { login: false });
}
/*
 * 用户信息
 * */
export function getUserInfo() {
    return request.get('userinfo');
}
/*
 * 退出登录
 * */
export function getLogout() {
    return request.get('logout');
}
/**
 * 提交更新推荐人
 * @param {*} data
 * @returns
 */
export function postChangeFather(data) {
    return request.post('user/changeFather', data);
}
/**
 * 提交实名认证
 * @param {Object} data
 */
export function postVerified(data) {
    return request.post('verified', data);
}
/**
 * 获取认证信息
 */
export function getVerified() {
    return request.get('verified');
}
/**
 * 个人资料
 * @returns
 */
export function getUserProfile() {
    return request.get('profile');
}
/**
 * 已报名课程
 * @param {*} q
 * @returns
 */
export function getUserClasses(q) {
    return request.get('user/classes', q);
}
/**
 * 我的预约
 * @param {*} q
 * @returns
 */
export function getUserReserve(q) {
    return request.get('user/reserve', q);
}
/**
 * 取消预约
 * @param {*} id
 * @returns
 */
export function cancelReserve(id) {
    return request.post('user/reserve/cancel/' + id);
}
/**
 * 签到
 * @param {*} id
 * @returns
 */
export function actionSignCourse(id, data) {
    return request.post('classes/course/sign/' + id, data);
}
